import React from 'react'
import { useTranslation } from 'react-i18next'

import { SvgImage } from 'components/SvgImage'

import earlySignsImage from 'assets/images/early-signs-image.webp'

import { StyledEarlySigns as S } from './EarlySigns.styles'
import { EARLY_SIGNS } from './constants'

export const EarlySigns: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Hero>
        <S.Image src={earlySignsImage} alt="" />

        <S.Intro>
          <S.Title>{t('onboarding.landingWellness.earlySigns.title')}</S.Title>
          <S.Description>
            {t('onboarding.landingWellness.earlySigns.description')}
          </S.Description>
        </S.Intro>
      </S.Hero>

      <S.List>
        <S.ListTitle>
          {t('onboarding.landingWellness.earlySigns.listTitle')}
        </S.ListTitle>

        <S.Signs>
          {EARLY_SIGNS.map(({ icon, titleKey, descriptionKey }) => (
            <S.Sign key={titleKey}>
              <S.SignIconBadge>
                <SvgImage svg={icon} width={20} height={20} />
              </S.SignIconBadge>

              <S.SignContent>
                <S.SignTitle>{t(titleKey)}</S.SignTitle>
                <S.SignDescription>{t(descriptionKey)}</S.SignDescription>
              </S.SignContent>
            </S.Sign>
          ))}
        </S.Signs>
      </S.List>
    </S.Wrapper>
  )
}
